const React = require("react");
const T = React.PropTypes; 

require("./Reports.less");

const UserType = require("~/types/User.js").PropType;
const ReportsType = require("~/types/Reports.js").PropType;
const CompleteReportType = require("~/types/CompleteReport.js").PropType; 
const DistrictReportType = require("~/types/DistrictReport.js").PropType;

const ReportDispatchers = require("~/events/reports/reportDispatchers.js");

const CompletedReportGrid = require("./CompletedReportGrid/CompletedReportGrid.jsx");

//Splits and reorders date strings so they can be ordered intuitively.
function dateStringSwitch(s) {
    s.split("");
    var s0 = s[0];
    var s1 = s[1];
    var s2 = s[2];
    var s3 = s[3];
    var s4 = s[4];
    var s5 = s[5];
    var s6 = s[6];

    return s = s3 + s4 + s5 + s6 + s2 + s0 + s1;
}
//Puts date strings back in their correct format so they can be looked up by audit functions.
function dateStringRevert(s) {
    s.split("");
    var s0 = s[0];
    var s1 = s[1];
    var s2 = s[2];
    var s3 = s[3];
    var s4 = s[4];
    var s5 = s[5];
    var s6 = s[6];

    return s = s5 + s6 + s4 + s0 + s1 + s2 + s3;
}

const Reports = React.createClass({
    PropTypes: {
        User: UserType.isRequired,
        Reports: ReportsType.isRequired,
        AuditPeriods: T.array,
        CompleteReport: CompleteReportType.isRequired,
        DistrictReport: DistrictReportType, 
        Loading: T.bool,
    },
    SelectedAudit: null,
    componentWillMount() { 
        if (this.props.AuditPeriods === null) { 
            ReportDispatchers.GetValidAuditPeriods(); 
        }
    }, 
    render () {
        const header = this.RenderHeader();
        const divisiondaterangesection = this.RenderDivisionDateRangeSection();
        const grid = this.RenderGrid(); 

        return (<article className="cs-Reports">
                {header}
                {divisiondaterangesection}
                {grid}
                </article>); 
    },
    RenderHeader () {

        return (<header>
                <h1 className="cs-Reports__header">Reports</h1>
                <div className="cs-Reports__selection-box">
                    <div>
                        <label>Audit Type</label>
                        <select className="form-control cs-Reports__selector"
                                onChange={this.AuditTypeChanged}
                                disabled={this.props.Loading}>
                         <option value="">Select an Audit</option>
                         <option value="Customer Readiness">Customer Readiness Audit</option>
                         <option value="Apartment Audit">Apartment Audit</option>
                         <option value="Facility Audit">Facility Audit</option>
                        </select>
                    </div>
                </div>
                </header>); 
    },
    RenderDivisionDateRangeSection() { 
        if (!this.props.Reports.SelectedAudit) {
            return null; 
        }

        const divisionOptions = this.props.User.Divisions
            .map((d) => {
                return (<option key={d.Number} value={d.Number }>{d.Number} - {d.Name}</option>); 
            });

       // Rarrange date string values, then reorder the array.
       var AuditListUO = this.props.AuditPeriods;
       var AuditListSplit = AuditListUO.map(function (dateString, index) { 
            return dateString= dateStringSwitch(dateString);
       });
       //Sort in reverse so most recent quarter is first.
       var AuditListOrderedBadStrings = AuditListSplit.sort().reverse();
       // Reorder the text again so it is formatted as expected by audit load code.
       var AuditList = AuditListOrderedBadStrings.map(function (dateStringReversed, index) {
           return dateStringReversed = dateStringRevert(dateStringReversed);
       });

       var dateRangeOptions = AuditList
                .map((p, index) => {
                    return (<option key={p} value={(p)}>{(p)}</option>);
                });

        return (<section>
            <div>
                <div className="cs-Reports__selection-box__same-line">
                        <label>Division</label>
                        <select className="form-control cs-Reports__selector"
                                onChange={this.DivisionChanged}
                                disabled={this.props.Loading}>
                            <option value="">Select a Division</option>
                            {divisionOptions}
                        </select>
                </div>
                <div className="cs-Reports__selection-box__same-line">
                        <label>Date Range</label>
                        <select className="form-control cs-Reports__selector"
                                onChange={this.DateRangeChanged}
                                disabled={this.props.Loading}>
                            <option value="">Select a Date</option>
                            {dateRangeOptions}
                        </select>
                </div>
            </div>
                </section>);  
    },
    RenderGrid() {

        if (!this.props.Reports.SelectedAudit || 
            !this.props.Reports.SelectedDivision) { 
            return null; 
        }


        if (this.props.CompleteReport != null) {

            if (this.props.Loading)
            {
                ReportDispatchers.LoadingCompleteReport(false); 
            }

            return (<CompletedReportGrid
                                     SelectedDivisionNumber={this.props.Reports.SelectedDivision.Number} 
                                     SelectedAuditType={this.SelectedAudit}
                                     SelectedAuditPeriod={"null"}
                                     CompleteReport={this.props.CompleteReport}
                                     DistrictReport={this.props.DistrictReport}
                                     DateRange={this.props.Reports.DateRange}
                                     />);
        }
        else if (this.props.Reports.DateRange == undefined || 
                 this.props.Reports.SelectedDivision === 'Select A Division') {
            return; 
        }
        else {

            if (!this.props.Loading)
            {
                ReportDispatchers.LoadingCompleteReport(true); 
            }

            return (<div className="cs-Reports__loading">

                    <div className="cs-Reports__loading__circle"></div>
    
                    </div>);
        }
    },
    AuditTypeChanged(e) {
        this.SelectedAudit = e.target.value;
        this.SelectedAudit = this.SelectedAudit.replace(/\s/g, '');
        this.ClearCompletionReport(); 
        ReportDispatchers.RegionSelectionsChanged(e.target.value, null, null, null);
    },
    DivisionChanged(e) {
        const selectedDivision = this.props.User.Divisions.find((d) => {
            return d.Number === e.target.value;
        }); 

        ReportDispatchers.RegionSelectionsChanged(this.props.Reports.SelectedAudit, selectedDivision, null, this.props.Reports.DateRange);

        if (this.props.Reports.DateRange !== undefined
            && this.props.Reports.DateRange !== 'Select A Date'
            && this.props.Reports.DateRange !== null)
            this.GetNewCompletionGrid(selectedDivision.Number, this.props.Reports.DateRange); 
    },
    DateRangeChanged(e) { 
        
        ReportDispatchers.RegionSelectionsChanged(this.props.Reports.SelectedAudit, this.props.Reports.SelectedDivision, null, e.target.value);

        if (this.props.Reports.SelectedDivision !== null
            && this.props.Reports.SelectedDivision !== 'Select A Division'
            && this.props.Reports.SelectedDivision !== undefined)
            this.GetNewCompletionGrid(this.props.Reports.SelectedDivision.Number, e.target.value); 
    },
    GetNewCompletionGrid(division, dateRange) {
        var d = dateRange.replace(" ", "-"); 
            ReportDispatchers.GetCompletionReport(division,
                                                   this.SelectedAudit,
                                                   d);
    },
    ClearCompletionReport() {
        ReportDispatchers.ClearCompletionReport(); 
    }
    });

module.exports = Reports; 


// WEBPACK FOOTER //
// ./src/components/Reports/Reports.jsx